import { render, staticRenderFns } from "./FormP9.vue?vue&type=template&id=37614e10&scoped=true"
import script from "./FormP9.vue?vue&type=script&lang=ts"
export * from "./FormP9.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=37614e10&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37614e10",
  null
  
)

export default component.exports